import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../constants';
import { useAdUnit } from '../../useAdUnit';
import DealerAdIframe from '../dealer';
const MobileDevPageVideoStage = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const isFreestar = useFlag('ads_freestar');
    const _useAdUnit = useAdUnit(AdProviders.Primis, ADUNIT_MAP['MobileDevPageVideoStageGam'], safety, {
        placementId: 113451,
        vpContent: 'plembed35b9omrwtkip',
        verticalOffset: isFreestar ? 102 : 50,
        clientOnly: true
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '300px',
                height: '200px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['MobileDevPageVideoStageGam'],
            neverCollapse: true,
            fillBlock: true
        }));
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
MobileDevPageVideoStage.displayName = 'MobileDevPageVideoStage';
export default MobileDevPageVideoStage;
